var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEmailSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 81,
    viewBox: "0 0 132 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.6311 67.3567H44.5358C40.829 67.3567 37.8215 64.3493 37.8215 60.6424V6.92815C37.8215 3.22131 40.829 0.213867 44.5358 0.213867H125.107C128.814 0.213867 131.822 3.22131 131.822 6.92815V31.5472H127.345V21.2704L122.134 23.0936L120.657 18.8666L127.345 16.5265V6.92815C127.345 6.33366 127.109 5.76535 126.69 5.34571C126.27 4.92606 125.702 4.69001 125.107 4.69001H44.5358C43.2987 4.69001 42.2977 5.69103 42.2977 6.92811V16.6989L85.2626 31.783L83.7851 35.9925L42.2977 21.4271V60.6424C42.2977 61.2369 42.5337 61.8052 42.9534 62.2248C43.373 62.6445 43.9413 62.8805 44.5358 62.8805H73.6311V67.3567Z",
    fill: "#01D83D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.321533 5.49902H35.3215V8.49902H0.321533V5.49902Z",
    fill: "#01D83D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5715 17.499H10.5715V20.499H35.5715V17.499Z",
    fill: "#01D83D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5715 29.499H35.5715V32.499H19.5715V29.499Z",
    fill: "#01D83D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M103.067 62.3558C103.758 64.0301 105.393 65.1185 107.202 65.1185C108.391 65.1185 109.528 64.6463 110.367 63.807C111.206 62.9677 111.679 61.8312 111.679 60.6422C111.679 58.8325 110.59 57.1977 108.916 56.507C107.242 55.812 105.318 56.1966 104.037 57.4774C102.757 58.7583 102.372 60.6816 103.067 62.3558Z",
    fill: "#01D83D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.2978 80.7857H125.107C128.814 80.7857 131.822 77.7783 131.822 74.0714V47.2143C131.822 43.5074 128.814 40.5 125.107 40.5H118.393V33.7852C118.393 27.6043 113.383 22.5947 107.202 22.5947C101.021 22.5947 96.012 27.6043 96.012 33.7852V40.5H89.2978C85.5909 40.5 82.5835 43.5074 82.5835 47.2143V74.0714C82.5835 77.7783 85.5909 80.7857 89.2978 80.7857ZM87.0597 47.2143C87.0597 45.9772 88.0607 44.9762 89.2978 44.9762L125.107 44.9761C125.702 44.9761 126.27 45.2122 126.69 45.6318C127.109 46.0515 127.345 46.6198 127.345 47.2143V74.0714C127.345 74.666 127.109 75.2342 126.69 75.6539C126.27 76.0735 125.702 76.3096 125.107 76.3096H89.2978C88.7033 76.3096 88.135 76.0735 87.7154 75.6539C87.2957 75.2342 87.0597 74.6659 87.0597 74.0714V47.2143ZM100.488 40.4995H113.917V33.7852C113.917 30.0784 110.909 27.0709 107.202 27.0709C103.496 27.0709 100.488 30.0784 100.488 33.7852V40.4995Z",
    fill: "#01D83D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmailSend);
export default __webpack_public_path__ + "static/media/Icon_EmailSend.81dfcd30.svg";
export { ForwardRef as ReactComponent };